import { IFormatObjectEditable } from "../IFormatObjectEditable";
import {
  instanceOfIQuestionnairePropertyEditable,
  IQuestionnairePropertyEditable,
  instanceOfIRectangleCoordinateEditable,
  IRectangleCoordinateEditable,
} from "../properties";

export type IDrawableQuestionnaireObjectEditable = IFormatObjectEditable & IQuestionnairePropertyEditable & IRectangleCoordinateEditable;

export function instanceOfIDrawableQuestionnaireObjectEditable(source: IFormatObjectEditable): source is IDrawableQuestionnaireObjectEditable {
  return source
      && instanceOfIQuestionnairePropertyEditable(source)
      && source.questionnaire().getValue().type
      && source.questionnaire().getValue().linkId
      && instanceOfIRectangleCoordinateEditable(source);
}
